export default {
  nav: {
    spreadsheet: 'Tableur',
    categories: 'Catégories',
    products: 'Produits',
    guides: 'Guides',
    reviews: 'Avis',
    shipping: 'Expédition',
    safety: 'Sécurité',
    comparisons: 'Comparaisons',
    faq: 'FAQ',
    mainSite: 'Site Principal',
  },
  languages: {
    en: 'English',
    fr: 'Français',
    da: 'Dansk',
    de: 'Deutsch',
  },
  hero: {
    h1: 'AllChinaBuy Spreadsheet — Trouvez des Produits, Vendeurs & Ressources d\'Achat',
    subtitle: 'Explorez le spreadsheet AllChinaBuy, les listes de produits, les ressources vendeurs, les guides QC, les informations d\'expédition et les conseils pratiques — tout organisé dans un hub facile à utiliser.',
    ctaPrimary: 'Explorer le Spreadsheet AllChinaBuy',
    ctaSecondary: 'Visiter le Site Principal',
    searchPlaceholder: 'Rechercher le spreadsheet AllChinaBuy, produits, vendeurs ou guides…',
    trust: 'Ressource Indépendante • Mise à Jour Régulière • Facile pour Débutants',
  },
  categories: {
    title: 'Catégories Populaires',
    subtitle: 'Parcourez les produits par catégorie et découvrez les meilleurs articles disponibles via AllChinaBuy',
    viewAll: 'Voir Toutes les Catégories',
  },
  dropdown: {
    label: 'Sélectionner une Catégorie',
    placeholder: 'Choisir une catégorie de produit...',
    goButton: 'Aller à la Catégorie',
  },
  ctas: {
    exploreTitle: 'AllChinaBuy Spreadsheet',
    exploreDesc: 'Accédez au spreadsheet complet de produits et vendeurs avec des liens sélectionnés et des informations mises à jour.',
    exploreButton: 'AllChinaBuy Spreadsheet',
    buyTitle: 'Acheter Maintenant',
    buyDesc: 'Passez la recherche et allez directement sur le site principal pour commencer vos achats immédiatement.',
    buyButton: 'Acheter Maintenant',
  },
  spreadsheet: {
    title: 'Explorateur de Spreadsheet',
    subtitle: 'Naviguez dans le spreadsheet AllChinaBuy avec facilité. Trouvez des produits, vendeurs et ressources organisés pour un accès rapide.',
    feature1: 'Liens Produits Sélectionnés',
    feature2: 'Annuaire Vendeurs Vérifiés',
    feature3: 'Mis à Jour Régulièrement',
    feature4: 'Facile pour Débutants',
  },
  featured: {
    title: 'Produits en Vedette',
    subtitle: 'Découvrez les articles tendance de la communauté spreadsheet AllChinaBuy',
  },
  guides: {
    title: 'Derniers Guides',
    subtitle: 'Guides étape par étape pour vous aider à rechercher, acheter et expédier des produits en toute sécurité',
    readMore: 'Lire le Guide',
    guide1Title: 'Guide Complet du Spreadsheet AllChinaBuy',
    guide1Desc: 'Apprenez tout sur l\'utilisation efficace du spreadsheet AllChinaBuy pour la recherche de produits.',
    guide2Title: 'Comment Trouver des Vendeurs Fiables',
    guide2Desc: 'Conseils essentiels pour évaluer la réputation des vendeurs et éviter les pièges courants.',
    guide3Title: 'Guide Expédition & Entrepôt',
    guide3Desc: 'Comparez les méthodes d\'expédition, calculez les coûts et choisissez la meilleure option de livraison.',
    guide4Title: 'Avis AllChinaBuy 2026',
    guide4Desc: 'Avis honnête et à jour de la plateforme AllChinaBuy, fonctionnalités et expérience utilisateur.',
  },
  trust: {
    title: 'Pourquoi Faire Confiance à Cette Ressource ?',
    independent: 'Plateforme Indépendante',
    independentDesc: 'Nous ne sommes pas affiliés à AllChinaBuy. Notre objectif est de fournir des informations honnêtes et utiles.',
    updated: 'Mise à Jour Régulière',
    updatedDesc: 'Le contenu est révisé et mis à jour pour refléter les derniers changements de plateforme et tarifs d\'expédition.',
    beginner: 'Facile pour Débutants',
    beginnerDesc: 'Des explications claires et des guides étape par étape facilitent le démarrage pour les nouveaux utilisateurs.',
  },
  searchCards: {
    title: 'Recherches Populaires',
    spreadsheet: 'Spreadsheet AllChinaBuy',
    review: 'Avis AllChinaBuy',
    shipping: 'Coût Expédition AllChinaBuy',
    coupon: 'Coupon AllChinaBuy',
    discount: 'Code Promo AllChinaBuy',
    warehouse: 'Entrepôt AllChinaBuy',
    legit: 'AllChinaBuy Légitime',
    qc: 'QC AllChinaBuy',
  },
  finalCta: {
    title: 'Prêt à Explorer Plus de Produits ?',
    subtitle: 'Utilisez nos guides pour rechercher d\'abord, puis continuez sur le site principal pour explorer plus de produits.',
    button: 'Continuer vers le Site Principal',
  },
  footer: {
    about: 'À Propos',
    contact: 'Contact',
    editorial: 'Politique Éditoriale',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    disclaimer: 'Avertissement',
    affiliate: 'Divulgation d\'Affiliation',
    description: 'Un hub de ressources indépendant pour les utilisateurs du spreadsheet AllChinaBuy. Nous aidons les acheteurs à rechercher des produits, vendeurs et options d\'expédition avant d\'acheter.',
    copyright: 'Tous droits réservés.',
    notAffiliated: 'Ce site est une ressource d\'information indépendante et n\'est pas le site officiel AllChinaBuy.',
  },
  breadcrumb: {
    home: 'Accueil',
  },
  article: {
    toc: 'Table des Matières',
    updated: 'Mis à jour',
    author: 'Auteur',
    readTime: 'min de lecture',
    related: 'Articles Connexes',
    backToHome: 'Retour à l\'Accueil',
  },
  faq: {
    title: 'Questions Fréquemment Posées',
    q1: 'Qu\'est-ce que le spreadsheet AllChinaBuy ?',
    a1: 'Le spreadsheet AllChinaBuy est une collection organisée de liens produits, d\'informations vendeurs et de ressources d\'achat pour aider les acheteurs à trouver des articles efficacement via la plateforme AllChinaBuy.',
    q2: 'AllChinaBuy est-il légitime ?',
    a2: 'AllChinaBuy est une plateforme d\'agent d\'achat légitime. Cependant, comme pour tout achat en ligne, les acheteurs doivent rechercher les vendeurs, vérifier les photos QC et comprendre les coûts d\'expédition avant de commander.',
    q3: 'Comment utiliser le spreadsheet AllChinaBuy ?',
    a3: 'Parcourez le spreadsheet par catégorie, cliquez sur les liens produits pour voir les détails, comparez les vendeurs et utilisez les liens fournis pour naviguer vers la plateforme AllChinaBuy pour l\'achat.',
    q4: 'Quelles méthodes d\'expédition AllChinaBuy propose-t-il ?',
    a4: 'AllChinaBuy propose plusieurs options d\'expédition incluant l\'express international, l\'expédition standard et la consolidation d\'entrepôt. Les coûts varient selon la destination et le poids du colis.',
  },
  comparison: {
    title: 'Comment AllChinaBuy se Compare',
    feature: 'Fonctionnalité',
    productDiscovery: 'Découverte de Produits',
    spreadsheetResources: 'Ressources Spreadsheet',
    qc: 'Photos QC',
    warehouse: 'Stockage Entrepôt',
    shipping: 'Options d\'Expédition',
    payment: 'Méthodes de Paiement',
    support: 'Support Client',
  },
  safety: {
    title: 'Centre de Sécurité',
    subtitle: 'Informations essentielles pour vous aider à acheter en toute sécurité et éviter les risques courants',
    payment: 'Sécurité Paiement',
    paymentDesc: 'Utilisez des méthodes de paiement sécurisées et ne partagez jamais vos identifiants avec les vendeurs directement.',
    verification: 'Vérification Vendeur',
    verificationDesc: 'Vérifiez les notes des vendeurs, l\'historique des avis et les retours de la communauté avant de passer commande.',
    qc: 'Sécurité QC',
    qcDesc: 'Demandez toujours et examinez les photos QC avant d\'approuver les expéditions depuis l\'entrepôt.',
    scams: 'Arnaques Courantes',
    scamsDesc: 'Apprenez à identifier les liens suspects, les faux vendeurs et les tentatives de phishing courantes.',
  },
};